// extracted by mini-css-extract-plugin
module.exports = {"addressItem":"helpModal_addressItem__-7jWr","termsModal":"helpModal_termsModal__1Kz9C"};